import * as React from 'react';
const PleaseReplyIcon = () => (
  <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask maskUnits="userSpaceOnUse" x={0} y={0} width={12} height={12}>
      <path fill="#D9D9D9" d="M0 0h12v12H0z" />
    </mask>
    <g>
      <path
        d="m3 10-1.15 1.15a.456.456 0 0 1-.544.106.47.47 0 0 1-.306-.469V3c0-.275.098-.51.294-.706A.963.963 0 0 1 2 2h5.05a2.544 2.544 0 0 0 0 1H2v6.563L2.575 9H10V4.95c.192-.042.37-.098.537-.169.167-.07.321-.164.463-.281V9c0 .275-.098.51-.294.706A.963.963 0 0 1 10 10H3Zm6.5-6c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 0 1 8 2.5c0-.417.146-.77.438-1.063A1.447 1.447 0 0 1 9.5 1c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062 0 .417-.146.77-.438 1.063A1.447 1.447 0 0 1 9.5 4Z"
        fill="#C8A311"
      />
      <circle cx={9.5} cy={3} r={2.5} fill="#E92C2C" />
    </g>
  </svg>
);
export default PleaseReplyIcon;
